import { useFormContext } from "react-hook-form";
import { Card, FlatActionList } from "@towersystems/roam-common-native";
import { useTranslation } from "react-i18next";
import { DocketTemplateFormValues } from "../types";
import Terminal from "../../../../../utilities/data/model/Terminal";
import { useDatabase } from "@nozbe/watermelondb/react";
import React from "react";
import colors from "react-native-ui-lib/src/style/colors";
import { Feather } from "@expo/vector-icons";

export interface TerminalIdsInputProps {
  terminals?: Terminal[];
}

export const TerminalIdsInput = (props: TerminalIdsInputProps) => {
  const [terminals, setTerminals] = React.useState<Terminal[] | undefined>(
    props.terminals
  );
  const database = useDatabase();
  const { t } = useTranslation("settings");
  const { watch, setValue } = useFormContext<DocketTemplateFormValues>();

  const watchedTerminalIds = watch("terminalIds");

  React.useEffect(() => {
    database.collections
      .get<Terminal>("terminals")
      .query()
      .observe()
      .subscribe(setTerminals);
  }, []);

  return (
    <FlatActionList
      items={(terminals || []).map((terminal) => ({
        key: terminal.id,
        title: terminal.name,
        onPress: () => {
          const selected = watchedTerminalIds.includes(terminal.id);
          if (selected) {
            setValue(
              "terminalIds",
              watchedTerminalIds.filter((id) => id !== terminal.id),
              {
                shouldDirty: true,
              }
            );
          } else {
            setValue("terminalIds", [...watchedTerminalIds, terminal.id], {
              shouldDirty: true,
            });
          }
        },
        componentRight: () => {
          const selected = watchedTerminalIds.includes(terminal.id);
          return (
            selected && (
              <Feather name="check" size={24} color={colors.primary} />
            )
          );
        },
      }))}
    ></FlatActionList>
  );
};
